"use client";

import React, { useEffect, useState } from "react";
import { House, Recycle, MapPin, Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  id: 1,
  value: 10,
  suffix: "+",
  label: "Years of Precision",
  icon: House
}, {
  id: 2,
  value: 100,
  suffix: "%",
  label: "UAE Based Operations",
  icon: MapPin
}, {
  id: 3,
  value: 24,
  suffix: "/7",
  label: "Enterprise Support",
  icon: Recycle
}, {
  id: 4,
  value: 0,
  suffix: "%",
  label: "Data Loss Recorded",
  icon: Star
}];
function StatCard({
  stat,
  index
}: {
  stat: typeof stats[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 2000;
    const end = stat.value;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isVisible, stat.value]);
  const Icon = stat.icon;
  return <div data-index={index} ref={ref} className="group relative flex flex-col items-center justify-center overflow-hidden rounded-md border-2 border-border bg-card/40 p-8 text-center shadow-lg backdrop-blur-sm transition-all hover:shadow-xl">
      <div className="absolute inset-0 translate-y-full bg-primary/10 transition-transform duration-500 ease-in-out group-hover:translate-y-0" />
      
      <div className="relative z-10 mb-6 rounded-md border-2 border-border bg-muted/50 p-4">
        <Icon className="size-8 text-primary" strokeWidth={2} />
      </div>
      
      <div className="relative z-10 mb-2 flex items-center font-default text-4xl font-bold tracking-tighter text-foreground md:text-5xl bg-gradient-to-br from-foreground to-muted-foreground bg-clip-text">
        {count.toLocaleString()}
        <span className="text-primary">{stat.suffix}</span>
      </div>
      
      <div className="relative z-10 font-mono text-xs font-semibold uppercase tracking-widest text-muted-foreground md:text-sm">
        {stat.label}
      </div>
    </div>;
}
export default function ByTheNumbers() {
  return <section data-section-id="225004" id="a-decade-of-precision" className="bg-background text-foreground">
      <div className="border-y-2 border-border bg-background py-20 lg:py-32 relative overflow-hidden">
        {}
        <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/uae_skyline_wireframe.png')] bg-cover bg-center" />
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="mx-auto mb-16 max-w-3xl text-center">
            <h2 className="mb-4 font-default text-3xl font-bold uppercase tracking-tighter text-foreground md:text-5xl">
              A Decade of <span className="text-primary">Precision</span>
            </h2>
            <p className="font-mono text-sm text-muted-foreground">
              Architecting resilient digital infrastructure for the UAE's leading enterprises since 2014.
            </p>
          </div>
          
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat, i) => <StatCard key={stat.id} stat={stat} index={i} />)}
          </div>
        </div>
      </div>
    </section>;
}